import * as React from "react";
import {
  BooleanField,
  Datagrid,
  DeleteWithConfirmButton,
  ExportButton,
  FunctionField,
  List,
  TextField,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { ExcelExport } from "../../../Helper/ExportExcel";
import PbhResponseTimeException from "./PbhResponseTimeException/PbhResponseTimeException";
import { CheckCircle } from "@material-ui/icons";
import { ButtonGroup } from "@material-ui/core";
import { CustomDateField } from "../../../Components/CustomDateField";

const CockpitResponseTimeViewList = props => {
  const ListActions = props => (
    <TopToolbar>
      <ExportButton {...props} maxResults={99999} />
    </TopToolbar>
  );

  const exporter = records => {
    const data = records.map(record => ({
      RefNo: record.refNo,
      Customer: record.customer,
      "Requirement Category": record.requirementCategory,
      "Response Time": record.responseTime,
      "Request Date": record.createdDate,
      "Confirm Date": record.confirmDate,
      "Is Exception": record.isException,
      "Exception Note": record.exceptionNote,
    }));

    const columns = Object.keys(data[0]).map(record => ({ header: record }));

    ExcelExport(columns, data, "Response Time List");
  };

  const ExceptionDeleteButton = props => {
    const record = useRecordContext();

    return (
      <DeleteWithConfirmButton
        confirmContent="Are you sure to delete this exception?"
        confirmTitle="Delete Exception"
        resource="pbhrequestresponsetimeexceptions"
        record={{ id: record.exceptionId }}
        redirect={false}
        mutationMode="pessimistic"
      />
    );
  };

  return (
    <List
      {...props}
      filterDefaultValues={props.filterParams}
      actions={<ListActions />}
      exporter={exporter}
      bulkActionButtons={false}
      filter={{ responseTime__gte: 60 }}
    >
      <Datagrid expand={<PbhResponseTimeException />} isRowExpandable={row => row.isException !== true}>
        <TextField source="refNo" />
        <TextField source="customer" />
        <TextField source="requirementCategory" />
        <TextField source="responseTime" />
        <CustomDateField source="createdDate" label="Request date" showTime />
        <CustomDateField source="confirmDate" showTime />
        <FunctionField
          label="Is exception"
          render={record => {
            return (
              <ButtonGroup>
                <BooleanField source="isException" TrueIcon={CheckCircle} />
                {record?.isException === true && <ExceptionDeleteButton />}
              </ButtonGroup>
            );
          }}
        />
        <TextField source="exceptionNote" />
      </Datagrid>
    </List>
  );
};

export default CockpitResponseTimeViewList;
